import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import {
  RiFacebookFill,
  RiInstagramLine,
  RiTwitterXFill,
  RiLinkedinFill,
  RiMailFill,
} from "react-icons/ri"
import * as styles from "@/styles/modules/SocialLinks.module.scss"

const SocialLinks = ({ className, showEmailIcon }) => {
  const data = useStaticQuery(graphql`
    {
      allSanityGeneral {
        nodes {
          generalSettings {
            facebookUrl
            instagramUrl
            twitterUrl
            linkedinUrl
            email
          }
        }
      }
    }
  `)

  const { facebookUrl, instagramUrl, twitterUrl, linkedinUrl, email } =
    data.allSanityGeneral.nodes[0].generalSettings

  return (
    <div className={[styles.wrapper, className ? className : ""].join(" ")}>
      {facebookUrl && (
        <a href={facebookUrl} aria-label="Check us out on Facebook">
          <RiFacebookFill
            className={`${styles.socialIcon} ${styles.facebook}`}
          />
        </a>
      )}
      {instagramUrl && (
        <a
          href={instagramUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="See whats cookin on our Instagram"
        >
          <RiInstagramLine
            className={`${styles.socialIcon} ${styles.instagram}`}
          />
        </a>
      )}
      {twitterUrl && (
        <a
          href={twitterUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="Follow us on Twitter"
        >
          <RiTwitterXFill
            className={`${styles.socialIcon} ${styles.twitter}`}
          />
        </a>
      )}
      {linkedinUrl && (
        <a
          href={linkedinUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="Follow us on LinkedIn"
        >
          <RiLinkedinFill
            className={`${styles.socialIcon} ${styles.linkedIn}`}
          />
        </a>
      )}
      {email && showEmailIcon && (
        <a
          href={`mailto:${email}`}
          target="_blank"
          rel="noreferrer"
          aria-label="Follow us on LinkedIn"
        >
          <RiMailFill className={`${styles.socialIcon} ${styles.email}`} />
        </a>
      )}
    </div>
  )
}

SocialLinks.defaultProps = {
  showEmailIcon: true,
}
SocialLinks.propTypes = {
  showEmailIcon: PropTypes.bool.isRequired,
}

export default SocialLinks
